// MainStem - UI
import { Button } from '@mainstem/react-mainstem'
// Styled Components
import styled from 'styled-components'

export const PaddedButton = styled(Button)`
  margin-right: 5px;
`
